import { useCallback } from 'react';

import { useProductFormStore } from '../store/productFormStore';
import { Artist, Category, KeywordGroup } from '../types/productTypes';

export const useSidebarInfo = () => {
  const {
    formData,
    setCategoryWithId,
    setVendor,
    addArtist,
    removeArtist,
    setTag,
    removeTag,
    addKeywordGroup,
    removeKeywordGroup,
    setReleaseDate,
    setSalesStartDate,
    setSalesEndDate,
    formatDateForInput,
  } = useProductFormStore();

  const handleCategoryChange = useCallback(
    (category: Category) => {
      setCategoryWithId(category.categoryId, category.categoryName);
    },
    [setCategoryWithId],
  );

  const handleArtistChange = useCallback(
    (artist: Artist, isSelected: boolean) => {
      if (isSelected) {
        addArtist(artist);
      } else {
        removeArtist(artist.artistId);
      }
    },
    [addArtist, removeArtist],
  );

  const handleArtistRemove = useCallback(
    (artistId: number) => {
      removeArtist(artistId);
    },
    [removeArtist],
  );

  const handleVendorChange = useCallback(
    (vendor: { id: number; vendor: string }) => {
      setVendor(vendor);
    },
    [setVendor],
  );

  const handleTagChange = useCallback(
    (tagId: number, tagName: string, isSelected: boolean) => {
      setTag(tagId, tagName, isSelected);
    },
    [setTag],
  );

  const handleTagRemove = useCallback(
    (tagId: number) => {
      removeTag(tagId);
    },
    [removeTag],
  );

  const handleKeywordGroupChange = useCallback(
    (keywordGroup: KeywordGroup, isSelected: boolean) => {
      if (isSelected) {
        addKeywordGroup(keywordGroup);
      } else {
        removeKeywordGroup(keywordGroup.keywordGroupId);
      }
    },
    [addKeywordGroup, removeKeywordGroup],
  );

  const handleKeywordGroupRemove = useCallback(
    (keywordGroupId: number) => {
      removeKeywordGroup(keywordGroupId);
    },
    [removeKeywordGroup],
  );

  const handleReleaseDateChange = useCallback(
    (date: string) => {
      setReleaseDate(date);
    },
    [setReleaseDate],
  );

  const handleSalesStartDateChange = useCallback(
    (date: string) => {
      setSalesStartDate(date);
    },
    [setSalesStartDate],
  );

  const handleSalesEndDateChange = useCallback(
    (date: string) => {
      setSalesEndDate(date);
    },
    [setSalesEndDate],
  );

  return {
    sidebarInfo: formData.sidebarInfo,
    handleCategoryChange,
    handleArtistChange,
    handleArtistRemove,
    handleVendorChange,
    handleTagChange,
    handleTagRemove,
    handleKeywordGroupChange,
    handleKeywordGroupRemove,
    handleReleaseDateChange,
    handleSalesStartDateChange,
    handleSalesEndDateChange,
    formatDateForInput,
  };
};
